import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const lightEmphasizedTextVars: MotifComponentProps<MotifComponent.EMPHASIZED_TEXT> = {
  '--emphasized-text-color': m('--fg-color'),
} as const;

export const darkEmphasizedTextVars: MotifComponentProps<MotifComponent.EMPHASIZED_TEXT> = {
  '--emphasized-text-color': m('--primary-v100'),
} as const;
